var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 267.05 229.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #454c52;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 110.98,
    y1: 175.42,
    x2: 133.64,
    y2: 180.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f26622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#a7282c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 194.01,
    y1: 135.04,
    x2: 170.85,
    y2: 266.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6fbe44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e5923"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.42,61.36c.24-1.44-.87-2.75-2.33-2.75H36.06s-33.69,0-33.69,0C1.06,58.61,0,59.67,0,60.97l.12,165.87c0,1.3,1.06,2.36,2.36,2.36h33.7c1.31,0,2.36-1.06,2.36-2.37l-.09-127.44c0-1.31,1.06-2.37,2.36-2.37h82.62c1.15,0,2.14-.83,2.33-1.97l5.65-33.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.06,190.78l-66.68-.03c-.96,0-1.74-.78-1.74-1.75v-37.39c0-.96.78-1.75,1.75-1.75h21.51c.85,0,1.57-.61,1.72-1.44l6.13-34.93c.19-1.07-.63-2.05-1.72-2.05H54.96c-.96,0-1.75.78-1.75,1.75v116.02h38.42v-.03l57.66.03c3.81,0,7.06-2.76,7.67-6.53l4.81-29.87c.17-1.06-.65-2.02-1.72-2.02Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.95,58.21L162.63.53c-2.47-1.39-5.58.07-6.07,2.87l-40.04,225.79,33.64.02c3.32,0,6.16-2.39,6.72-5.67l17.97-105.2c.28-1.67,1.56-2.99,3.22-3.34l80.74-16.83c1.68-.35,2.97-1.71,3.23-3.41l4.96-32.35c.26-1.69-.56-3.37-2.05-4.21ZM183.33,71.12l2.4-10.12c.64-2.7,3.72-4.01,6.11-2.59l11.9,7.09c3.22,1.92,2.41,6.79-1.25,7.56l-14.3,3.03c-2.95.63-5.56-2.04-4.86-4.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcp);
export default __webpack_public_path__ + "static/media/FCP.370cec73cad701a88cd23c9c92f72b54.svg";
export { ForwardRef as ReactComponent };